var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            width: _vm.formData.width,
            title: _vm.formData.title,
            modal: true,
            "close-on-click-modal": false,
            "custom-class": "person",
            "show-close": true,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "mt20",
                  attrs: {
                    model: _vm.tableFrom,
                    rules: _vm.rules,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "info" },
                    [
                      _c(
                        "el-alert",
                        {
                          staticClass: "cr-alert",
                          attrs: {
                            title: "",
                            closable: false,
                            type: "info",
                            "show-icon": true,
                          },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c("p", [
                              _vm._v(
                                "您账号的密码为初始值,为了账号安全,建议您修改密码"
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "密码", prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          type: "password",
                          "auto-complete": "on",
                          placeholder: _vm.$t("login.title2"),
                        },
                        model: {
                          value: _vm.tableFrom.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "password", $$v)
                          },
                          expression: "tableFrom.password",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "确认密码", prop: "password_confirm" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          type: "password",
                          "auto-complete": "on",
                          placeholder: "请输入确认密码",
                        },
                        model: {
                          value: _vm.tableFrom.password_confirm,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "password_confirm", $$v)
                          },
                          expression: "tableFrom.password_confirm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleClose()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("public.ok")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }